<template>
  <base-card
    :scrollable="true"
    :heading="heading"
    :icons="['plus']"
    @icon-clicked="iconClicked"
  >
    <contact-list-item
      class="scs-note-item-wrapper"
      v-for="(note, index) in notes"
      :key="index"
      :note="note"
      @toggle-visibility="toggleNoteVisibility(note, index)"
      @delete-note="deleteNote(note, index)"
    >
    </contact-list-item>
  </base-card>
</template>
<script>
import BaseCard from "./UI/BaseCard.vue";
import ContactListItem from "./UI/ListItems/Notes/Contact.vue";

export default {
  data() {
    return {};
  },
  computed: {
    notes() {
      let array = [];

      if (this.contact) {
        if (this.contact.notes) {
          return this.contact.notes;
        } else {
          return array;
        }
      } else if (this.event) {
        return this.event.notes;
      } else {
        return array;
      }
    },
  },
  methods: {
    toggleNoteVisibility(note, index) {
      console.log(note, index);
      // todo : build lambda to toggle note visibility
    },
    async deleteNote(note, index) {
      if (this.event) {
        let parameters = {
          subject: this.event,
          api_version: this.event.api_version,
          variable: "notes",
          value: this.note,
          eventKey: {
            userId: this.event.userId,
            tenantId: this.event.tenantId,
          },
          index: index,
          operation: "remove",
        };
        await this.$store.dispatch("editEvent", parameters);
      }
      //  todo build lambda to delete note from contact
    },
    iconClicked(icon) {
      switch (icon) {
        case "plus":
          this.$emit("open-add-note");
          break;

        default:
          break;
      }
    },
  },
  created() {},
  components: {
    BaseCard,

    ContactListItem,
  },
  emits: ["open-add-note"],
  props: ["contact", "heading", "event"],
};
</script>
<style scoped></style>
